module.exports = __webpack_public_path__ + "images/top_icon_close.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/top_icon_close.png
// module id = 899
// module chunks = 127